var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParlamentDark(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "45px",
    viewBox: "0 0 55 45",
    style: {
      enableBackground: "new 0 0 55 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#DCD8C9;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12.4,35.1 12.4,33.2 20.4,33.2 20.4,33.2 20.4,33.2 33.3,33.2 33.3,33.2 33.3,33.2 42.6,33.2  42.6,35.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "37.3,32.1 37.3,29.5 35.6,27.7 35.6,22.9 19.4,22.9 19.4,27.7 17.7,29.5 17.7,32.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,32.1l6.4-2c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l6.4,2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.1,32.1 3.1,27.9 2.5,26.4 3.1,26.4 11.4,26.4 12,26.4 11.4,27.9 11.4,32.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.1,42.6 3.1,36.2 11.4,36.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,20.7c2.6,0.3,3.3,3.1,3.5,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.2,25.4c0.2-1.6,1-4.6,3.9-4.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "35.6,21.9 36.3,20.7 36.3,19 35.6,17.8 19.4,17.8 18.7,19 18.7,20.7 19.4,21.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,20.9c-0.1,0-6.7-3.9-12.9,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,16.8c0.5-1.8,1.8-5.3,5.8-6.5V7.9c0,0-0.1-1.9,1.7-2.3h0.7c1.8,0.5,1.7,2.3,1.7,2.3v2.3 c4,1.2,5.3,4.7,5.8,6.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.1,35.1 3.1,33.2 11.4,33.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.1,20.7c2.8,0.2,3.5,3.1,3.7,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.7,25.4c0.2-1.6,0.9-4.5,3.7-4.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "43.6,32.1 43.6,27.9 43,26.4 43.6,26.4 51.9,26.4 52.5,26.4 51.9,27.9 51.9,32.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "17.1,36.2 12.4,36.2 12.4,42.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "42.6,42.6 42.6,36.2 37.9,36.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "51.9,35.1 51.9,33.2 43.6,33.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "43.6,36.2 51.9,36.2 51.9,42.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "23.2,36.2 18.1,36.2 18.1,42.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "36.9,42.6 36.9,36.2 31.8,36.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "30.7,42.6 30.7,36.2 24.3,36.2 24.3,42.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.5,
    y1: 5.6,
    x2: 27.5,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.7,
    y1: 3.4,
    x2: 26.3,
    y2: 3.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.5,
    y1: 15.5,
    x2: 7.5,
    y2: 20.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 47.8,
    y1: 15.5,
    x2: 47.8,
    y2: 20.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 32.1,
    y1: 24,
    x2: 32.1,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.3,
    y1: 24,
    x2: 30.3,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.5,
    y1: 24,
    x2: 28.5,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 26.7,
    y1: 24,
    x2: 26.7,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.9,
    y1: 24,
    x2: 24.9,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.1,
    y1: 24,
    x2: 23.1,
    y2: 27.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParlamentDark);
export default __webpack_public_path__ + "static/media/parlament-dark.4684155ffbfa4b7d5521ce463b7b9d2a.svg";
export { ForwardRef as ReactComponent };